import Main from './main.element.js';

export default Main;

Main.define('wje-main', Main);
